module.exports = __webpack_public_path__ + "img/zl6.9465a86c.png";